import React, { useState, useEffect } from 'react';
import './Video.css';

export default function Video() {
  const [videos, setVideos] = useState({ live: [], lyric: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [active, setActive] = useState(null);

  useEffect(() => {
    fetch('/videos.json')
      .then((res) => { if (!res.ok) throw new Error(); return res.json(); })
      .then((data) => { setVideos(data); setLoading(false); })
      .catch(() => { setError(true); setLoading(false); });
  }, []);

  if (loading) return (
    <div><div className="section-container">
      <h1 className="section-title">Video</h1>
      <div className="section-rule" />
      <div className="video-status"><div className="video-spinner" /></div>
    </div></div>
  );

  if (error) return (
    <div><div className="section-container">
      <h1 className="section-title">Video</h1>
      <div className="section-rule" />
      <div className="video-status video-status--warn">
        <p>Couldn't load videos. Please try again later.</p>
        <a href="https://www.youtube.com/@EchoHillBand916" target="_blank" rel="noopener noreferrer" className="yt-btn" style={{ marginTop: 16 }}>
          <YTIcon /> Watch on YouTube
        </a>
      </div>
    </div></div>
  );

  return (
    <div>
      <div className="section-container">
        <h1 className="section-title">Video</h1>
        <div className="section-rule" />

        <div className="video-page-header">
          <a href="https://www.youtube.com/@EchoHillBand916" target="_blank" rel="noopener noreferrer" className="yt-btn">
            <YTIcon /> Subscribe on YouTube
          </a>
        </div>

        {videos.live?.length > 0 && (
          <VideoSection heading="Live" videos={videos.live} active={active} onPlay={setActive} />
        )}
        {videos.lyric?.length > 0 && (
          <VideoSection heading="Lyric Videos" videos={videos.lyric} active={active} onPlay={setActive} />
        )}
      </div>
    </div>
  );
}

function VideoSection({ heading, videos, active, onPlay }) {
  return (
    <div className="video-section">
      <h2 className="video-section-heading">{heading}</h2>
      <div className="video-section-rule" />
      <div className="video-grid">
        {videos.map((v) => (
          <VideoCard key={v.id} video={v} isActive={active === v.id} onPlay={() => onPlay(v.id)} />
        ))}
      </div>
    </div>
  );
}

function VideoCard({ video, isActive, onPlay }) {
  const { id, title } = video;
  return (
    <div className="video-card-outer">
      <div className="video-card">
        {isActive ? (
          <iframe
            src={`https://www.youtube.com/embed/${id}?autoplay=1`}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ border: 0, position: 'absolute', inset: 0, width: '100%', height: '100%' }}
          />
        ) : (
          <button className="video-thumb" onClick={onPlay} aria-label={`Play ${title}`}>
            <img
              src={`https://img.youtube.com/vi/${id}/maxresdefault.jpg`}
              alt={title}
              className="video-thumb-img"
              onError={(e) => { e.target.src = `https://img.youtube.com/vi/${id}/hqdefault.jpg`; }}
            />
            <div className="video-play-overlay">
              <div className="video-play-btn">
                <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
          </button>
        )}
      </div>
      <div className="video-meta">
        <p className="video-title">{title}</p>
      </div>
    </div>
  );
}

function YTIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
      <path d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z" />
    </svg>
  );
}
